export const IMAGE_STATIC = {
  award_apps:
    "https://storage.googleapis.com/img.myfitsociety.com/app-assets/wreath_appstore_playstore_black_2026.png",
  global_startup_award:
    "https://storage.googleapis.com/img.myfitsociety.com/app-assets/wreath_global_startup_awards_black.png",
  table_comparision_white: {
    desktop_en:
      "/static/app-assets/comparison-table/white/desktop_en.webp",
    desktop_id:
      "/static/app-assets/comparison-table/white/desktop_id.webp",
    mobile_en:
      "/static/app-assets/comparison-table/white/mobile_en.webp",
    mobile_id:
      "/static/app-assets/comparison-table/white/mobile_id.webp",
  },
  table_comparision_black: {
    desktop_en:
      "/static/app-assets/comparison-table/black/desktop_en.webp",
    desktop_id:
      "/static/app-assets/comparison-table/black/desktop_id.webp",
    mobile_en:
      "/static/app-assets/comparison-table/black/mobile_en.webp",
    mobile_id:
      "/static/app-assets/comparison-table/black/mobile_id.webp",
  },
};
